import { inject, injectable } from 'tsyringe';
import { type ICompanyUserTokenRepository } from 'application/repositorySchemas/ICompanyUserTokenRepository';
import { type ICompanyRequestSubsidyInfoRepository } from 'application/repositorySchemas/ICompanyRequestSubsidyInfoRepository';
import { type ICompanyRequestSubsidyInfoClient } from 'interfaceAdapter/gatewaySchemas/ICompanyRequestSubsidyInfoClient';

@injectable()
export class CompanyRequestSubsidyInfoRepository implements ICompanyRequestSubsidyInfoRepository {
    constructor(
        @inject('ICompanyUserTokenRepository')
        public readonly companyUserToken: ICompanyUserTokenRepository,
        @inject('ICompanyRequestSubsidyInfoClient')
        public readonly companyRequestSubsidyInfoClient: ICompanyRequestSubsidyInfoClient,
    ) {}

    public async request() {
        const { data, message } = await this.companyRequestSubsidyInfoClient.post({
            token: this.companyUserToken.get() || '',
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }
}
